import { lazy, Suspense } from "react";
import PageLoader from "components/PageLoader";

const LazyOverview = lazy(() => import('pages/Overview'));

const OverviewRoute = () => (
  <Suspense fallback={<PageLoader />}>
    <LazyOverview />
  </Suspense>
);

export default OverviewRoute;
